import { Trade } from "./trade";
import { CryptoTransaction, GenericTransaction, IndexTransaction, TradableTransaction } from "@models/transaction";

export class BestFeeCollection {
	private best_current_price_eur: string = "";
	private best_used_price_eur: string = "";
	private bfc_deduction: number = 0;
	private bfc_market_value_eur: string = "";
	private wallet_transaction: CryptoTransaction = new CryptoTransaction();
	private related_trade: Trade = new Trade();
	private related_wallet_transaction: GenericTransaction = new GenericTransaction();
	private related_index_action: IndexTransaction = new IndexTransaction();

	public getCurrentBestPriceEur(): string {
		return this.best_current_price_eur;
	}

	public getUsedBestPriceEur(): string {
		return this.best_used_price_eur;
	}

	public getBestPercentage(): string {
		return this.bfc_deduction * 100 + "%";
	}

	public getBestDeduction(): number {
		return this.bfc_deduction;
	}

	public getBfcMarketValueEur(): string {
		return this.bfc_market_value_eur;
	}

	public getRelatedBestTransaction(): CryptoTransaction {
		return this.wallet_transaction;
	}

	public getRelatedBestTrade(): Trade {
		return this.related_trade;
	}

	public getRelatedWalletTransaction(): TradableTransaction {
		return this.related_wallet_transaction;
	}

	public getRelatedIndexTransaction(): TradableTransaction {
		return this.related_index_action;
	}
}
